module.exports = __webpack_public_path__ + "static/media/360dude_dark.89c85f5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/01/assets/360dude_dark.svg
// module id = 352
// module chunks = 0